import axios from "axios";

const api = axios.create({
  baseURL: "https://ws.qrperk.com",
});

export default api